module.exports = __webpack_public_path__ + "img/icon1.f26fd7f1.png";